/**
 * Variant min quantity web component.
 * Listens for variant:change and updates quantity input min/value and min quantity text.
 */
class VariantMinQuantity extends HTMLElement {
  constructor() {
    super();
    this._variantChangeHandler = this._handleVariantChange.bind(this);
  }

  connectedCallback() {
    const minQuantitiesEl = this.querySelector("[data-min-quantities]");
    if (!minQuantitiesEl) return;

    this._minimumQuantities = JSON.parse(minQuantitiesEl.textContent);
    this._quantityInput = this.querySelector(".quantity-selector__input");
    this._quantityText = this.querySelector("[data-min-quantity-text]");

    if (!this._quantityInput) return;

    this._fallbackMinQuantity = this._minimumQuantities.find((v) => v.id === "fallback")?.minQuantity;

    document.addEventListener("variant:change", this._variantChangeHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:change", this._variantChangeHandler);
  }

  _handleVariantChange(event) {
    const newVariantId = event.detail.variant.id;
    const variantData = this._minimumQuantities.find((v) => v.id == newVariantId);
    const minQuantity = variantData?.minQuantity ?? this._fallbackMinQuantity ?? 1;

    this._quantityInput.min = minQuantity;
    this._quantityInput.value = minQuantity;

    if (this._quantityText) {
      if (minQuantity > 1) {
        const template = window.themeVariables?.strings?.minQuantity ?? "Minimum @@";
        this._quantityText.textContent = template.replace("@@", minQuantity);
        this._quantityText.hidden = false;
      } else {
        this._quantityText.hidden = true;
      }
    }
  }
}

customElements.define("variant-min-quantity", VariantMinQuantity);
